import { render } from "./ProsesInfoBeranda.vue?vue&type=template&id=dba844e4"
import script from "./ProsesInfoBeranda.vue?vue&type=script&lang=js"
export * from "./ProsesInfoBeranda.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__